import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderService } from '@/services/header-service.interface';
import { accountDeferred } from '@eureka/utils/account';

export const HeaderServiceProxy = Symbol('HeaderServiceProxy');
// 检查用户是否是企业用户
export interface HeaderServiceProxy {
    headerService: HeaderService;
}

@injectable()
export class HeaderServiceProxyImpl implements HeaderServiceProxy {
    constructor(
        @inject(HeaderService)
        public headerService: HeaderService
    ) {
        this.headerService.visibleProducts = false;
        Promise.all([accountDeferred.promise]).then(([account]) => {
            this.headerService.deferred.promise.then(() => {
                // 只有企业用户才显示产品切换
                this.headerService.visibleProducts = !!account?._info?.company_id;
            });
        });
    }
}